import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-star',
  templateUrl: './icon-star.component.html',
  styleUrls: ['./icon-star.component.scss'],
})
export class IconStarComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
